import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { useGoToReorderView } from '../../hooks/useJsonComponentNavigation';

// Tip:
// This component renders when creating or editing your custom component type.
// props.isEditMode === true when editing, and === false when creating.
export const DefaultThingsToDoEdit = (props: AdminSidebarComponentProps) => {
  const { goToReorderView } = useGoToReorderView();

  return (
    <>
      <TextV2>Editing your new DefaultThingsToDo</TextV2>
      <TextV2 onClick={goToReorderView}>{JSON.stringify(props.data.content)}</TextV2>
    </>
  );
};
